import MobileVersion from './MobileVersion';
import Hotjar from './Hotjar';

const hotjar = new Hotjar();
export default new class ComprarEntradas {
    constructor() {

    }

    initialize() {
        const $btnsComprar = document.getElementsByClassName('btnComprar');
        if (!$btnsComprar)
            return;

        const mobileVersion = new MobileVersion();
        $.each($btnsComprar, function () {
            this.addEventListener('click', e => {
                hotjar.tagRecording('comprar_entradas');
                if (mobileVersion.isMobile()) {
                    e.preventDefault();
                    mobileVersion.SendEventMobile('COMPRAR_ENTRADAS', e.currentTarget.href);
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/ComprarEntradas.js